import { render } from "./roleDeleteConformationDialog.vue?vue&type=template&id=45e77978"
import script from "./roleDeleteConformationDialog.vue?vue&type=script&lang=js"
export * from "./roleDeleteConformationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__